import React from "react";
import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { useI18n } from "../i18n";

export default function Footer() {
  const { lang, t, dict } = useI18n();
  const base = `/${lang}`;

  return (
    <footer
      className="bg-[#0C111D] text-white border-t border-[#0C111D]"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link
              to={base}
              className="flex items-center gap-3 no-underline text-white"
              data-testid="footer-brand-link"
            >
              <span className="inline-flex h-9 w-9 items-center justify-center bg-white text-[#0C111D]">
                <Building2 size={18} strokeWidth={1.75} />
              </span>
              <span className="font-serif text-2xl tracking-tight">
                {t("footer.brand")}
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-[#D1D5DB] max-w-sm">
              {t("footer.tagline")}
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs uppercase tracking-widest font-bold text-white/70">
              {t("footer.legalTitle2")}
            </h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link
                  to={`${base}/privacy-policy`}
                  data-testid="footer-link-privacy"
                  className="text-sm text-white hover:text-white/70 no-underline"
                >
                  {t("footer.legal.privacy")}
                </Link>
              </li>
              <li>
                <Link
                  to={`${base}/cookie-policy`}
                  data-testid="footer-link-cookies"
                  className="text-sm text-white hover:text-white/70 no-underline"
                >
                  {t("footer.legal.cookies")}
                </Link>
              </li>
              <li>
                <Link
                  to={`${base}/terms`}
                  data-testid="footer-link-terms"
                  className="text-sm text-white hover:text-white/70 no-underline"
                >
                  {t("footer.legal.terms")}
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-xs uppercase tracking-widest font-bold text-white/70">
              {t("footer.legalTitle")}
            </h3>
            <ul className="mt-4 space-y-1.5 text-sm text-[#D1D5DB] leading-relaxed">
              {dict.footer.legalLines.map((line, i) => (
                <li key={i} data-testid={`footer-legal-line-${i}`}>
                  {line}
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-xs uppercase tracking-widest font-bold text-white/70">
              {t("footer.contactTitle")}
            </h3>
            <ul className="mt-4 space-y-1.5 text-sm text-[#D1D5DB]">
              {dict.footer.contactLines.map((line, i) => (
                <li key={i}>{line}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 grid gap-6 md:grid-cols-3">
          <p className="md:col-span-2 text-xs text-[#9CA3AF] leading-relaxed max-w-3xl">
            {t("footer.disclaimer")}
          </p>
          <p
            className="text-xs text-[#9CA3AF] md:text-right"
            data-testid="footer-copyright"
          >
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}
